import axiosInstance from "auth/FetchInterceptor";
import { PREFIX } from "constants/ApiConstant";
const PhanCaTrucService = {};

PhanCaTrucService.search = function (data) {
  return axiosInstance.post(`${PREFIX}/PhanCaTruc/search`, data);
};

PhanCaTrucService.detail = function (id) {
  return axiosInstance.get(`${PREFIX}/PhanCaTruc/detail?id=${id}`);
};

PhanCaTrucService.upsert = function (data) {
  return axiosInstance.post(`${PREFIX}/PhanCaTruc/up-sert`, data);
};

PhanCaTrucService.hideColumn = function (data) {
  return axiosInstance.put(`${PREFIX}/PhanCaTruc/hide-column`, data);
};

PhanCaTrucService.upSertPhanCaTrucChiTiet = function (data) {
  return axiosInstance.post(`${PREFIX}/PhanCaTruc/ChiTiet/up-sert`, data);
};

PhanCaTrucService.export = function (id) {
  return axiosInstance.get(`${PREFIX}/PhanCaTruc/ChiTiet/export-excel/${id}`);
};

PhanCaTrucService.getAllThietLapViTri = function (branchId) {
  return axiosInstance.get(
    `${PREFIX}/PhanCaTruc/ThietLapViTri/search?branchId=${branchId}`
  );
};

PhanCaTrucService.getThietLapViTriById = function (id) {
  return axiosInstance.get(
    `${PREFIX}/PhanCaTruc/ThietLapViTri/detail?id=${id}`
  );
};

PhanCaTrucService.upsertThietLapViTri = function (data) {
  return axiosInstance.post(`${PREFIX}/PhanCaTruc/ThietLapViTri/up-sert`, data);
};

PhanCaTrucService.getPhanCaTrucHeaderTableByBranchId = function (branchId) {
  return axiosInstance.get(
    `${PREFIX}/PhanCaTruc/ThietLapViTri/get-header-table?branchId=${branchId}`
  );
};

PhanCaTrucService.searchPhieuDoiLich = function (data) {
  return axiosInstance.post(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichTruc/search`,
    data
  );
};

PhanCaTrucService.getPhieuDoiLich = function (id) {
  return axiosInstance.get(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichTruc/detail?id=${id}`
  );
};

PhanCaTrucService.getPhieuDoiLichByNgayTruc = function (data) {
  return axiosInstance.post(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichTruc/get-by-ngay-truc`,
    data
  );
};

PhanCaTrucService.upSertPhieuDoiLich = function (data) {
  return axiosInstance.post(
    `${PREFIX}/PhanCaTruc/PhieuDoiLichTruc/up-sert`,
    data
  );
};

export default PhanCaTrucService;
